import ModalForm from 'components/commons/modal-form'
import { InputOTPContainer } from '../../containers/login/InputOTPContainer'
import { InlineError } from 'avo-ui'

export const Verification = ({ show, value, onChangeOTP, closeModal, errorForm, isLoading, onSubmit }) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={closeModal}
            title={'Input OTP'}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 items-center justify-center p-5 bg-white rounded-xl'}>
                <p className={'text-sm font-semibold mb-4'}>Input OTP, Please Check Your Email</p>
                <InputOTPContainer cols={4} value={value} onChange={onChangeOTP} />
                <InlineError className={'mt-2 mx-auto'} message={errorForm?.otp_code} />
            </div>
        </ModalForm>
    )
}
